import type { PerUnitProductVariant } from '@weft/services';
import { isMultiple, removeInIndex } from '@weft/utils';
import { TrashIcon } from 'apps/app/src/components/icons/TrashIcon';
import cn from 'classnames';
import React, { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import type { PlanInputForm } from '../../../../CreatePlanForm/create-plan-form-types/plan-input-form';
import { PerUnitUsageChargeEditVariantsListItem } from './PerUnitUsageChargeEditVariantsListItem';

type PerUnitUsageChargeEditVariantsListProps = {
  variants: PerUnitProductVariant[];
  productIndex: number;
};

export const PerUnitUsageChargeEditVariantsList: React.FC<PerUnitUsageChargeEditVariantsListProps> = ({ variants, productIndex }) => {
  const { getValues, setValue } = useFormContext<PlanInputForm>();
  const productVariants = getValues(`usageProducts.${productIndex}.variants`);

  const onDelete = useCallback((productVariantIndex: number) => {
    const updatedProductVariants = removeInIndex(productVariants, productVariantIndex);
    setValue(`usageProducts.${productIndex}.variants`, updatedProductVariants);
  }, [productIndex, productVariants]);

  return (
    <div className="grid grid-cols-1 gap-5">
      {variants.map((variant, variantIndex) => (
        <div
          key={variant.id} 
          className={cn('even:bg-product-bk flex flex-row-reverse justify-between', variantIndex === 0 ? 'px-8' : 'pl-8')}
        >
          {isMultiple(variants) && variantIndex != 0 && (
            <TrashIcon
              className='fill-icon mx-3 my-2 h-full'
              onClick={() => onDelete(variantIndex)}
            />
          )}
          <div className='grow'>
            <PerUnitUsageChargeEditVariantsListItem
              key={variant.id}
              variant={variant}
              productIndex={productIndex}
              variantIndex={variantIndex}
            />
          </div>

        </div>
      ))}
    </div>
  );
};
